import { Injectable } from '@angular/core';
import { HttpClientService } from '@core/services/http-client/http-client.service';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
import { DataGrid } from '@sharedModule/models/data-grid.model';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { removeEmptyStrings } from '@sharedModule/utils/form.utils';
import { Observable } from 'rxjs';
import { AddWalletInterface } from '../types/add-wallet';
import { WalletListInterface } from '../types/wallet-list';
import {
  WalletListFilter,
  defaultWalletListFilter,
} from '../types/wallet-list-filter';

@Injectable({
  providedIn: 'root',
})
export class WalletService {
  constructor(private httpClient: HttpClientService) {}

  getPartnerWalletList(
    payload: WalletListFilter = defaultWalletListFilter
  ): Observable<ResponseIdentity<DataGrid<WalletListInterface[]>>> {
    return this.httpClient.post(
      API_URL_CONSTANT.wallet.getPartnerWalletList,
      removeEmptyStrings(payload)
    );
  }

  addPartnerWallet(
    payload: AddWalletInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.wallet.addPartnerWallet,
      payload
    );
  }

  getSenderWalletList(
    payload: WalletListFilter = defaultWalletListFilter
  ): Observable<ResponseIdentity<DataGrid<WalletListInterface[]>>> {
    return this.httpClient.post(
      API_URL_CONSTANT.wallet.getSenderWalletList,
      removeEmptyStrings(payload)
    );
  }

  addSenderWallet(
    payload: AddWalletInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.wallet.addSenderWallet,
      payload
    );
  }
}
